<template>
  <div class="platform-menu">
    <div class="menu-grid">
      <div
        class="menu-item"
        v-for="item in platformMenus"
        :key="item.title"
        @click="goMenu(item)"
      >
        <i class="iconfont menu-icon" :class="[item.color, item.iconClass]"></i>
        <span class="menu-item-title">{{ item.title }}</span>
      </div>
      <div class="menu-item" v-for="(item, index) in navs" :key="'ad-' + index" @click="goAdUrl(item)">
        <img class="menu-item-icon" :src="item.adv_code" />
        <span class="menu-item-title">{{item.adv_title}}</span>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { getJoininApplication } from '../../../api/joinin'

export default {
  name: 'HomeMenu',
  props: ['items'],
  data () {
    return {
      platformMenus: [
        { title: 'Suppliers', iconClass: 'icon-dianpu', routeName: 'HomeStorelist', color: 'green' },
        { title: 'Snap up', iconClass: 'icon-xianshiqianggou', routeName: 'HomeGroupBuyList', color: 'red' },
        { title: 'Vouchers', iconClass: 'icon-youhuiquan', routeName: 'HomeVoucherlist', color: 'purple' },
        { title: 'Become a Seller', iconClass: 'icon-jinrudianpu', routeName: 'HomeSellerJoinin1', color: 'gold' }
      ]
    }
  },
  computed: {
    ...mapState({
      navs: state => state.home.navs
    })
  },
  methods: {
    goMenu (item) {
      if (item.routeName === 'HomeSellerJoinin1' && this.$store.state.member.isOnline) {
        getJoininApplication().then(res => {
          const application = res.result.store_joinin
          const state = application ? Number(application.joinin_state) : 0
          if (state === 40) {
            this.$router.push({ name: this.$store.state.seller.isOnline ? 'SellerIndex' : 'HomeSellerLogin' })
          } else if (state === 20) {
            this.$router.push({ name: 'HomeSellerJoinin3' })
          } else if (state === 10 || state === 11 || state === 30 || state === 31) {
            this.$router.push({ name: 'HomeSellerJoinin4' })
          } else {
            this.$router.push({ name: item.routeName, query: item.query || {} })
          }
        }).catch(() => this.$router.push({ name: item.routeName, query: item.query || {} }))
        return
      }
      this.$router.push({ name: item.routeName, query: item.query || {} })
    },
    goAdUrl (item) {
      switch (item.adv_type) {
        case 'goods':
          this.$router.push({ name: 'HomeGoodsdetail', query: { goods_id: item.adv_typedate } })
          break
        case 'store':
          this.$router.push({ name: 'HomeStoredetail', query: { id: item.adv_typedate } })
          break
        case 'article':
          this.$router.push({ name: 'HomeArticledetail', query: { article_id: item.adv_typedate } })
          break
        case 'url':
          window.location.href = item.adv_typedate
          break
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.platform-menu {
  background: #fff;
  margin-top: 0.45rem;
  padding: 0.65rem 0.55rem 0.35rem;
}
.menu-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 0.45rem 0.2rem;
}
.menu-item {
  min-width: 0;
  text-align: center;
}
.menu-icon,
.menu-item-icon {
  display: block;
  width: 1.8rem;
  height: 1.8rem;
  line-height: 1.8rem;
  margin: 0 auto;
  border-radius: 0.34rem;
  overflow: hidden;
}
.menu-icon {
  color: #fff;
  font-size: 1rem;
}
.menu-item-icon {
  object-fit: cover;
}
.menu-item-title {
  display: block;
  color: #313b47;
  font-size: .54rem;
  line-height: 0.72rem;
  margin-top: .25rem;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.blue {
  background: #2563eb;
}
.green {
  background: #16805c;
}
.orange {
  background: #c26113;
}
.red {
  background: #c2410c;
}
.purple {
  background: #7c3aed;
}
.teal {
  background: #0f766e;
}
.gold {
  background: #b45309;
}
.slate {
  background: #334155;
}
</style>
